import React from 'react';
import styles from "./styles";
import axios from 'axios'
import axiosConfig from '../../../../config/axios.config'

const ContactDisplay = (props) => {
  const {pi, index, type, nct, protocol} = props;
  const [email, setEmail] = React.useState(pi.emailNotifications)

  const radioCheck = (e) => {
    if(e.target && e.target.value === 'Yes') setEmail(true)
    if(e.target && e.target.value === 'No') setEmail(false)
    axios.post(`${axiosConfig.apiUrl}/rt/console/contactUpdate/${props.instance}/${props.email}`, {index, type, nct,protocol, email: e.target.value})
      .then()
      .catch(err => console.log(err))
  }

  return <div key={index} style={{display: 'inline-block', marginRight: 8}}>
    <p style={styles.ctmsP}><b>CTMS Contact</b></p>
      {pi.name && <p style={styles.ctmsP}><b>Name</b> {pi.name}</p>}
      {pi.email && <p style={styles.ctmsP}><b>Email</b> {pi.email}</p>}
      {pi.phone && <p style={styles.ctmsP}><b>Phone</b> {pi.phone}</p>}
      {pi.emailNotifications !== undefined &&
      <p style={styles.ctmsP}><b>Email notification</b>
        <React.Fragment><input onClick={radioCheck} type='radio' checked={email} value='Yes' name={`Yes${pi.name}`} /> Yes</React.Fragment>
        <React.Fragment><input onClick={radioCheck} type='radio' checked={!email} value='No' name={`No${pi.name}`} /> No</React.Fragment>
      </p>}
  </div>
}

export default ContactDisplay;
